import { CubeCamera, OrbitControls, PerspectiveCamera, SpotLight } from '@react-three/drei'
import { Canvas } from '@react-three/fiber'
import React from 'react'
import * as THREE from 'three'
import { useState } from 'react'
import { animate, motionValue } from "framer-motion"

const Viewer3D = ({object}) => {
  const [pos, setPos] = useState([1.5, 1.6, 0])

  return (
    <>
      <div className='aspect-square max-h-screen max-w-screen-lg w-full h-full'>
        <Canvas>
          <OrbitControls makeDefault />
          {object}
          <ambientLight intensity={Math.PI / 2} />
        </Canvas>
      </div>
  
    </>
  )
}

export default Viewer3D